import { createFileRoute, redirect } from "@tanstack/react-router";

import { beforeGuestGuard } from "@/features/auth/guards";

// The public marketing site now owns "/" (apps/marketing, served on the apex /
// www host). The advisor app's root is no longer a landing page: authenticated
// users are routed to their role-appropriate home by beforeGuestGuard; everyone
// else is sent to sign-in.
export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    await beforeGuestGuard();
    throw redirect({ to: "/signin" });
  },
});
